import { ShopProductCategory } from "../../queries/shop";

export const nextLevelType = (item: ShopProductCategory) => {
  const hasChildren = item.children?.nodes.some(
    (el) => el.children && el.children?.nodes.length > 0
  );

  return hasChildren ? "inline" : "column";
};
